import React, { useState, useEffect, Component, useRef, forwardRef } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGameAssessment";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { debug } from "util";
import { render } from "react-dom";
//import style from './Geo.module.css';
import { Textfit } from 'react-textfit';

import style from '../../components/Geo.module.css';
import { Scale } from 'react-scaling';
//modes
import AsCalculator from "../../components/AsCalculator";
import AsCalculatorFraction from "../../components/AsCalculatorFraction";
import AsCalculatorFractionMixed from "../../components/AsCalculatorFractionMixed";

import axios from "axios";
import useAuth from "../../../auth/hooks/useAuth";

import next from "../../assets/maths_assessments/assets/Next.png";
import back from "../../assets/maths_assessments/assets/Back.png";
import blankbg from "../../assets/maths_assessments/assets/Blank.png";
import marks1 from "../../assets/maths_assessments/assets/marks1.png";

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;
var image;
var timer = -1;

//THESE VARIABLES NEED TO BE OUTSIDE THE EXPORT OTHERWISE THEY ARE SET TO DEFAULT EVERY FRAME
var questionNum = 0;
var useranswers = [];

//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}


export default function SummerAr({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const { state: authState } = useAuth();
  const [gameOver, setGameOver] = useState(false);

  const [clearCalc, setClear] = useState(false);

  //this.calculator = React.createRef();


  /*
  const { questions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });*/
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [extraChars, setExtraChars] = useState([]);
  const [refresh, setRefresh] = useState(false)
  const [displayImage, setDisplayImage] = useState(false);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(2);

  const [status, setStatus] = useState(false);

  //0 = keypad, 
  //1 = multiple choice,
  // 2 = fraction,
  // 3 = int & frac

  //questions section
  var questionsY1Summer = [];
  questionsY1Summer.push({ "question" : "4 + 1 =", "answer" : "5", "type": 0, "units" : "", "marks" : 1})
  questionsY1Summer.push({ "question" : "5 + _ = 9", "answer" : "4", "type": 0, "units" : "", "marks" : 1})
  questionsY1Summer.push({ "question" : "10 - 4 =", "answer" : "6", "type": 0, "units" : "", "marks" : 1})
  questionsY1Summer.push({ "question" : "17 - 5 =", "answer" : "12", "type": 0, "units" : "", "marks" : 1})
  questionsY1Summer.push({ "question" : "Half of 20 =", "answer" : "10", "type": 0, "units" : "", "marks" : 1})
  questionsY1Summer.push({ "question" : "_ = 9 + 7", "answer" : "16", "type": 0, "units" : "", "marks" : 1})
  questionsY1Summer.push({ "question" : "11 - _ = 11", "answer" : "0", "type": 0, "units" : "", "marks" : 1})
  questionsY1Summer.push({ "question" : "1 less than 34 =", "answer" : "33", "type": 0, "units" : "", "marks" : 1})
  questionsY1Summer.push({ "question" : "14 + 4  = 10 + _", "answer" : "8", "type": 0, "units" : "", "marks" : 1})
  questionsY1Summer.push({ "question" : "A quarter of _ = 2", "answer" : "8", "type": 0, "units" : "", "marks" : 1})
  

  var questionsY2Summer = [];
  questionsY2Summer.push({ "question" : "9 – 5 =", "answer" : "4", "type": 0, "units" : "", "marks" : 1})
questionsY2Summer.push({ "question" : "9 + 6 =", "answer" : "15", "type": 0, "units" : "", "marks" : 1})
questionsY2Summer.push({ "question" : "1 more than _ = 50", "answer" : "49", "type": 0, "units" : "", "marks" : 1})
questionsY2Summer.push({ "question" : "23 + 5 =", "answer" : "28", "type": 0, "units" : "", "marks" : 1})
questionsY2Summer.push({ "question" : "1/2 of 10 =", "answer" : "5", "type": 0, "units" : "", "marks" : 1})
questionsY2Summer.push({ "question" : "50 + 30 + 10 =", "answer" : "90", "type": 0, "units" : "", "marks" : 1})
questionsY2Summer.push({ "question" : "7 × 5 =", "answer" : "35", "type": 0, "units" : "", "marks" : 1})
questionsY2Summer.push({ "question" : "40 ÷ 10 =", "answer" : "4", "type": 0, "units" : "", "marks" : 1})
questionsY2Summer.push({ "question" : "70 = 30 + _", "answer" : "40", "type": 0, "units" : "", "marks" : 1})
questionsY2Summer.push({ "question" : "68 + 25 =", "answer" : "93", "type": 0, "units" : "", "marks" : 1})
questionsY2Summer.push({ "question" : "1/3 of 18", "answer" : "6", "type": 0, "units" : "", "marks" : 1})
questionsY2Summer.push({ "question" : "82 - 34 = ", "answer" : "48", "type": 0, "units" : "", "marks" : 1})
questionsY2Summer.push({ "question" : "100 – 29 =", "answer" : "71", "type": 0, "units" : "", "marks" : 1})
questionsY2Summer.push({ "question" : "3/4 of 24", "answer" : "18", "type": 0, "units" : "", "marks" : 1})
questionsY2Summer.push({ "question" : "57 - _ = 49", "answer" : "8", "type": 0, "units" : "", "marks" : 1})


  var questionsY3Summer = [];
  questionsY3Summer.push({ "question" : "82 + 10 =", "answer" : "92", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "4 + 4 + 4 =", "answer" : "12", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "_ = 47 + 33", "answer" : "80", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "4 × 5 =", "answer" : "20", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "£800 – £_ = £600", "answer" : "200", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "55 ÷ 5 =", "answer" : "11", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "186 – 27 =", "answer" : "159", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "603 + 98 =", "answer" : "701", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "1/4 of 24 =", "answer" : "6", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "3/11 + 3/11 =", "answer" : "6/11", "type": 2, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "932 – 127 =", "answer" : "805", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "36 ÷ _ = 4", "answer" : "9", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "199 + 235 =", "answer" : "434", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "55 × 4 =", "answer" : "220", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "5/6 + _ = 1", "answer" : "1/6", "type": 2, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "440 – _ = 310 +100", "answer" : "30", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "2/3 of 27 =", "answer" : "18", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "473 ml + _ml = 755ml", "answer" : "282", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "600 – 392 =", "answer" : "208", "type": 0, "units" : "", "marks" : 1})
questionsY3Summer.push({ "question" : "3 × 40 = 150 –", "answer" : "30", "type": 0, "units" : "", "marks" : 1})

  

  var questionsY4Summer = [];
  questionsY4Summer.push({ "question" : "4 x 9 = ", "answer" : "36", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "134 + 25 =", "answer" : "159", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "32 ÷ 8 = ", "answer" : "4", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "2,350 - 1,000 =", "answer" : "1350", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "3/5 + 1/5 =", "answer" : "4/5", "type": 2, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "335 + 195 =", "answer" : "530", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "1/6 of 48 =", "answer" : "8", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "_ = 55 x 5", "answer" : "275", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "3,408 + 226 = ", "answer" : "3634", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "3 x 8 = _ x 4", "answer" : "6", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "10/6 - 5/6 =", "answer" : "5/6", "type": 2, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "4/9 of 63 =", "answer" : "28", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "£55.98 - £27.63 = £_._", "answer" : "28.35", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "7 ÷ 10 = ", "answer" : "0.7", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "4 x 3 x 5 = ", "answer" : "60", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "0.26 + _ = 1", "answer" : "0.74", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "78 ÷ 6 = ", "answer" : "13", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "28 ÷ 100 =", "answer" : "0.28", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "263 x 7 = ", "answer" : "1841", "type": 0, "units" : "", "marks" : 1})
questionsY4Summer.push({ "question" : "225 - 152 = _ + 50", "answer" : "23", "type": 0, "units" : "", "marks" : 1})


  var questionsY5Summer = [];
  questionsY5Summer.push({ "question" : "123 + 262 =", "answer" : "385", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "100 – _ = 20", "answer" : "80", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "81 ÷ 9 =", "answer" : "9", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "_ = 6,450 – 1,000", "answer" : "5450", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "2/7 + 3/7 = ", "answer" : "5/7", "type": 2, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "3² = ", "answer" : "9", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "44 × 6 =", "answer" : "264", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "_ × £155 = £1,550", "answer" : "10", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "17,061 + 4,919 =", "answer" : "21980", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "3 × 8 = _ x 4", "answer" : "6", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "3/4 - 1/2 =", "answer" : "1/4", "type": 2, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "2/3 of 2,400m = _m", "answer" : "1600", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "173 × 5 =", "answer" : "865", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "7/11 x 3 = ", "answer" : "1&10/11", "type": 3, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "858 ÷ 6 =", "answer" : "143", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "6.34 × 100 = ", "answer" : "634", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "32 × 49 =", "answer" : "1568", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "74 + _ = 10,000", "answer" : "9926", "type": 0, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "1 4/7 + 1 9/14 =", "answer" : "3&3/14", "type": 3, "units" : "", "marks" : 1})
questionsY5Summer.push({ "question" : "396 × 17 =", "answer" : "6732", "type": 0, "units" : "", "marks" : 1})

  
  var questionsY6Summer = [];
  questionsY6Summer.push({ "question" : "546 + 1,832 =", "answer" : "2378", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "12 × 6 =", "answer" : "72", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "8 × 1,000 =", "answer" : "8000", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "41,000 – 100 =", "answer" : "40900", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "706 ÷ 10 =", "answer" : "70.6", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "4/9 - 2/9 = 1/9 + _", "answer" : "1/9", "type": 2, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "8 x _ = 56", "answer" : "7", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "3² = ", "answer" : "9", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "136 × 3 =", "answer" : "408", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "27,893 + 9,999 =", "answer" : "37892", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "15.3 x _ = 1,530", "answer" : "100", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "2 3/4 + 3 4/5 = ", "answer" : "6&11/20", "type": 3, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "4,812 ÷ 6 =", "answer" : "802", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "1.05 × 5 =", "answer" : "5.25", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "20% of 180 =", "answer" : "36", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "2/3 x 390 =", "answer" : "260", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "1,523 × 24 =", "answer" : "36552", "type": 0, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "2/9 x 1/2 =", "answer" : "1/9", "type": 2, "units" : "", "marks" : 1})
questionsY6Summer.push({ "question" : "3,588 ÷ 26 =", "answer" : "138", "type": 0, "units" : "", "marks" : 1})


//above is questions section
  
  const [questions, setQuestions] = useState([]);
  console.log(props);

  

  if (status == false){
    currQuestion = [];
    questionNum = 0;
    useranswers = [];
    //check what questions it is, checking year first will check terms later like summer etc
    if (props.assessment_type[0] == "1"){
      timer = -1;
      setQuestions(questionsY1Summer);
    } else if (props.assessment_type[0] == "2"){
      timer = -1;
      setQuestions(questionsY2Summer);
    } else if (props.assessment_type[0] == "3"){
      timer = 1200;
      setQuestions(questionsY3Summer);
    } else if (props.assessment_type[0] == "4"){
      timer = 1200;
      setQuestions(questionsY4Summer);
    } else if (props.assessment_type[0] == "5"){
      timer = 1500;
      setQuestions(questionsY5Summer);
    } else if (props.assessment_type[0] == "6"){
      timer = 1500;
      setQuestions(questionsY6Summer);
    }
    setStatus(true);
  }
  console.log(questions);

  if (useranswers.length == 0 && questions.length > 0){
    for (let i = 0; i < questions.length; i++) {
      useranswers.push("");
    }
    console.log("initial Answers array:")
    console.log(useranswers);
  }

  var questionMax = -1;
  if(props.minimum > 0)
  {
      questionMax = props.minimum;
  }

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  console.log("question number: " + questionNum);

  /*TODO: 
  only submit at the end
  may need to scrap a lot of the core code and do it from the ground up
  create a new calculator class just for assessments
  the background image method needs to set it equal to currentquestion number

  */

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    //questionNum++;
    currQuestion = questions[questionNum];
    console.log("Current question");
    console.log(currQuestion);
    console.log("Answers so far:");
    console.log(useranswers);
    setCurrentQuestion(currQuestion);
    setRefresh(!refresh);
    //CheckImage();
  }


  //Called on click
  async function checkResult(value, callback) {
    var isCorrect = true;
    if (value) {
      console.log(value.value + " " + currQuestion.correct);
      //correct answer
      if (currQuestion.correct === value.value) {
        setCorrectQuestions([...correctQuestions, currQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }

        newQuestion();
      }
      //incorrect answer
      else {
        isCorrect = false;
        setIncorrectQuestions([...incorrectQuestions, currQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }
      //Generates a new question
      //newQuestion();

    }
  }

  function MultipleButtons() {
    console.log(currentQuestion);
    return "blank"
  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else {

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      console.log(questions);
      var sample = questions[questionNum];
      currQuestion = sample;
      setCurrentQuestion(currQuestion);
      //CheckImage();
    }
  }, [questions]);

  //No clue
  useEffect(() => {
    if (status !== undefined && status == true) {
      setLoading(false);
    }
  }, [status]);


  function QuestionImage() {
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return blankbg;
    }
    var requireString = "Year"+props.assessment_type[0];
    if (props.assessment_type[3] == "ar"){
      requireString+= "/ARSummerEnd";
    }else if (props.assessment_type[4]){
      requireString+= "/RESummerEnd";
    }
    requireString += "/year"+props.assessment_type[0]+"question"+(questionNum+1)+".png";
    return (require("../../assets/maths_assessments/assets/"+requireString))
}

async function setAnswer(value)
  {
    console.log("SET VALUE");
    console.log(value);
    useranswers[questionNum] = value;
    console.log(useranswers);
  }

  function NavigationButtons(){
    if (questionNum != 0 && questionNum != questions.length){
      return (
        <div>
        <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>
        <NavigationButton
        onClick={() => nextQuestion()}>
          <NavigationText>
            Next
          </NavigationText>
        </NavigationButton>
        </div>
      );
    }else if (questionNum < questions.length){
      return (
      <div>
      <NavigationButton
      onClick={() => nextQuestion()}>
        <NavigationText>
          Next
        </NavigationText>
        
      </NavigationButton>
      </div>
      );
    }
    else{
      return (
        <div>
         <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>

        <Button onClick={() => GameOver()} style={{fontSize: "3em", height: "100px", width: "300px", position: "relative", right: "-45%", textAlign: "center", lineHeight: "3.2"}}>
          Submit
        </Button>
        </div>
        );
    }
  }

  function GameOver(){
    setGameOver(true);//go to endscreen
  }

  function ShowMarks(){
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return "";
    }else{
      return marks1;
    }
  }

  function CompareIfCorrect(youranswer, question){
    if (question.type != 1){
      if (question.answer == youranswer){
        return true;
      }else{
        return false;
      }
    }else{
      var correct = question.answer.split("|")[0];
      if (youranswer == correct){
        return true;
      }else{
        return false;
      }
    }
  }

  //I moved this to be called from the practicegameassessment script so it is done on timeout and ending game
  async function SubmitAssessment(){
     var correct = 0;      
    var questionsAnswered = [];
    for (let i = 0; i < questions.length; i++) {
        if (CompareIfCorrect(useranswers[i], questions[i])){
          let data = {
            question: questions[i].question,
            correct: true,
            answer: useranswers[i]
        };
        correct++;
        questionsAnswered.push(data);
        }else{
          let data = {
            question: questions[i].question,
            correct: false,
            answer: useranswers[i]
        };
        questionsAnswered.push(data);
        }
      console.log(JSON.stringify(questionsAnswered));
    }

    var topicstats = [];
    let temptih = {
      topic_key : "mathsassessmentsub",
      game_key : "basic_mathments",
      num_asked : questionsAnswered.length,
      num_correct : correct,
      average_ans_time : "0.0"
    }
    topicstats.push(temptih);

    axios({
        url: `${process.env.REACT_APP_API}/submissions`,
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authState.access_token}`
        },
        data: {
            "homework_id": props.homework.id,
            "topicstats": topicstats,
            "custom": null,
            "platform": "Assessment|" + "WEB" + "|" + process.env.REACT_APP_VERSION_NO,
            "game_id": props.homework.galaxy_id,
            "questionsAnswered": JSON.stringify(questionsAnswered)
        }
      }).then((response) => {
        setGameOver(true);//go to endscreen
      })
  }

  function SubmitTimeout(){
    SubmitAssessment();
  }

  
  async function nextQuestion(value)
  {
    questionNum++;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
    //setClear(true);
  }

  function ResetClear(){
    setClear(false);
  }

  async function previousQuestion(value)
  {
    questionNum--;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
  }

  //this returns a table that ticks what questions are done
  function GetEndTable(){
    var html = "";
    html+= "<div>"
    //create a table where it equals amount of questions
    html+= '<table style="margin-top: 20%; width:100%; border-collapse: collapse;">'
    html+= '<tr>'

    for (let i = 0; i < questions.length; i++) {
      console.log(i);
      html+= '<td style="height: 100px, text-align:center; font-size: 4em;">'
      html+= 'Q'+(i+1);
      html+= '</td>';
    }
    html+='</tr><tr>';
    
    useranswers.forEach(element => {
      if (element == ""){
        html+= '<td style="height: 100px; border: 1px solid #9999;"> </td>'
      }else{
        html+= '<td style="height: 100px; background: #FFA500; border: 1px solid #9999;"> </td>'
      }
    });
    html+= "</tr>";
    html+="</table>";
    html+= "</div>";

    return html;
  }

  //I don't know how to comment html/CSS
  return (
    <>
      <PracticeGame
        parent={props}
        gameOver={gameOver}
        SubmitMethod={() => SubmitTimeout()}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionNum={questionNum}
        questionNumMax ={questions.length}
        questionLimit={questionMax}
        onBack={() => props.onBack()}
        loading={loading}
        feedback={feedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
        }}
      >
        <div id="scalinghere">
        <div style={{ backgroundImage: `url(${ShowMarks()}), url(${QuestionImage()})`, position: "relative", top: "-10%", height: "1400px", backgroundSize: "cover" }} >

            <Body>
              
              <div style={{ width: "80%" }}>
                {currQuestion != undefined ? (


                  <Container update={refresh}>

                    <div style={{ display: "flex", flexDirection: "row", alignSelf: "flex-end" }}>
                        <div style={{
                          position: "relative",
                          top: "15%",
                          right: "5%",
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between"
                        }}>
                          {currQuestion.type == 0 &&
                            <AsCalculator
                            onChange={setAnswer}
                            fakeprop={true}
                            resetclear = {ResetClear}
                            currentQuestion={currQuestion}
                            currentAnswer={useranswers[questionNum]}
                            //ref={this.calculator}
                            />
                          }
                          {currQuestion.type == 1 &&
                            MultipleButtons()
                            }
                {currQuestion.type == 2 &&
                 <AsCalculatorFraction
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                 {currQuestion.type == 3 &&
                 <AsCalculatorFractionMixed
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                          
                        </div>
                    </div>
                    
                    <NavigationContainer>
                    {NavigationButtons()}
                    </NavigationContainer>

                  </Container>

                ) : <div>
                  <div dangerouslySetInnerHTML={{ __html: GetEndTable() }}>
                </div><NavigationContainer>{NavigationButtons()}</NavigationContainer></div> }
              </div>
            </Body>
        </div>
        </div>
      </PracticeGame>
    </>
  );
}

const NavigationContainer = styled.div`
  position: fixed;
  top: 70%;
  right: 50%;
`

const Body = styled.div`
        width: 100%;
        height: 100%;
  background-image: url("");
        background-size: cover;
        background-position: 0px -1px;
        display: flex;
        justify-content: center;
        padding-top: 100px;
      `;

const Result = styled.div`
        width: 100%;
        height: 100%;
        font-size: 5em;
        text-align: center;
        border: solid 2px #683d8c;
      `;

const Combo = styled.div`
        background: #4391bb;
        width: 120px;
        height: 120px;
        border-radius: 75px;
        border: solid #204b7b 4px;
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #fff;
        justify-content: center;
        font-weight: 600;
        margin-left: 50px;
      `;

const Container = styled.div`
      width:100%%;
      height:95%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

const Question = styled.div`
      background: #FFF;
      user-select: none;
      width: 90%;
      height: 120px;
      line-height: 90px;
      font-size: 4em;
      margin: 15px 25px;
      text-align: center;
      font-weight: 600;
      border: none;
      border-radius: 10px;
    `;

const Button = styled.div`
    text-align: center;
    width: 20%;
    height: 150px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: rgb(234, 146, 19);
    background: linear-gradient(
      0deg,
      rgba(234, 146, 19, 1) 0%,
      rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const NavigationButton = styled.div`
    text-align: center;
    width: 118px;
    height: 144px;
    margin: 5px;
    position: absolute;
    right: -1000px;
    top: 150px
    background-image: url(${next});
    color: #000;
    user-select: none;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const NavigationButtonBack = styled.div`
    text-align: center;
    width: 118px;
    height: 144px;
    margin: 5px;
    position: absolute;
    top: 150px;
    right: 1000px
    background-image: url(${back});
    color: #000;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const NavigationText = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}
  `;

  const NavigationTextBack = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  `;

const ButtonImage = styled.img`
max-width: 80%;
max-height: 80%;
padding-top: 15px;
`